export default [
    {
        id: 1,
        name: 'Wildness',
        other: ['Mitwirkender'],
        percentage: 12,
        cost: 'ab CHF 1200.00'
    },
    {
        id: 2,
        name: 'Bubbles',
        other: ['Produzent'],
        percentage: 12,
        cost: 'ohne Vorschuss'
    },
    {
        id: 3,
        name: 'Into The Wild',
        other: ['Produzent', 'Mitwirkender'],
        percentage: 12,
        cost: 'ohne Vorschuss'
    },
    {
        id: 4,
        name: 'Krime Time',
        other: ['Mitwirkender'],
        percentage: 5,
        cost: 'ab CHF 500.00'
    },
    {
        id: 5,
        name: 'There Is No Way',
        other: ['Mitwirkender'],
        percentage: 5,
        cost: 'ab CHF 500.00'
    }]



// WEBPACK FOOTER //
// ./src/data/neue.js